import { render, staticRenderFns } from "./textCmp.vue?vue&type=template&id=2b0dfb07&scoped=true&"
import script from "./textCmp.vue?vue&type=script&lang=js&"
export * from "./textCmp.vue?vue&type=script&lang=js&"
import style0 from "./textCmp.vue?vue&type=style&index=0&id=2b0dfb07&prod&scoped=true&lang=scss&"
import style1 from "./textCmp.vue?vue&type=style&index=1&id=2b0dfb07&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0dfb07",
  null
  
)

export default component.exports